import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const Disclaimer = () => {
  return (
    <LegalPageTemplate 
      title="Disclaimer"
    >
      <div className="prose max-w-none">
        <div className="space-y-6">
          <p>
            The content included on this website is for indicative purposes only and is not intended 
            to constitute specialist or personal advice. This website cannot provide a complete 
            statement of all information without consideration of your financial and other requirements 
            and objectives and your complete financial situation.
          </p>

          <p>
            We recommend that you have personal contact with the team at JDP Finance before taking 
            any credit action. Credit law demands that all loan applications must be subjected to a 
            responsible lending assessment to establish whether the loan would be not unsuitable and 
            this assessment is undertaken by representatives from JDP Finance.
          </p>
        </div>
      </div>
    </LegalPageTemplate>
  );
};

export default Disclaimer; 